// Urban Oasis Centralized Image Library
// All images use standardized naming: urbanoasis.[location].[identifier]
// This file serves as the single source of truth for all images across the site

// ==================== CASCAIS IMAGES ====================
export const cascaisPageImages = [
  {
    id: 'urbanoasis.cascais.001',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/5rf7wzfa_233107-Tamariz-Beach.webp',
    title: 'Tamariz Beach',
    subtitle: 'Sandy shores with historic fortress views'
  },
  {
    id: 'urbanoasis.cascais.002',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/tf697b1l_233029-Guincho-Beach.jpg',
    title: 'Guincho Beach',
    subtitle: 'Wild Atlantic waves perfect for surfing'
  },
  {
    id: 'urbanoasis.cascais.003',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/ntsl74iu_6490449b163c4990b04cc94d_63c993c9940a871e83673b89_shutterstock_2165976849%20%281%29.jpg',
    title: 'Estoril Casino & Gardens',
    subtitle: 'Iconic entertainment venue with manicured park and fountains'
  },
  {
    id: 'urbanoasis.cascais.004',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/1g0qo41k_adobestock-1200061770-1500x870.jpeg',
    title: 'Parque Marechal Carmona',
    subtitle: 'Scenic green parks and gardens'
  },
  {
    id: 'urbanoasis.cascais.005',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/0ac8nn53_Cascais.webp',
    title: 'Iconic Cascais Sign',
    subtitle: 'Downtown town square with historic architecture'
  },
  {
    id: 'urbanoasis.cascais.006',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/c8qrz5xe_dp-couple-cascais.jpg',
    title: 'Bay Viewpoint',
    subtitle: 'Couples enjoying panoramic beach views'
  },
  {
    id: 'urbanoasis.cascais.007',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/p5ienctw_1_W8ICmFBAnDVLfB4YE9__GA.jpg',
    title: 'Cascais Market',
    subtitle: 'Fresh local produce and vibrant community hub'
  },
  {
    id: 'urbanoasis.cascais.008',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/qoef13o0_AdobeStock_256954815-Boca-do-inferno-e1556820826239.jpeg',
    title: 'Boca do Inferno',
    subtitle: "Hell's Mouth - dramatic cliff formation and natural wonder"
  },
  {
    id: 'urbanoasis.cascais.009',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/ixqwinw6_Cascais2.webp',
    title: 'Santa Marta Lighthouse',
    subtitle: 'Historic beacon overlooking azure waters'
  },
  {
    id: 'urbanoasis.cascais.010',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/v37a65cq_dreamstime_l_83026949-scaled.jpg',
    title: 'Coastal Paradise',
    subtitle: 'Aerial view of pristine beaches and town'
  },
  {
    id: 'urbanoasis.cascais.011',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/k6yqv88b_patios-visita-guiada-casa-pilatos-naturanda-1.webp',
    title: 'Palace Gardens',
    subtitle: 'Historic courtyards and Portuguese tilework'
  },
  {
    id: 'urbanoasis.cascais.012',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/nfbg5gef_232426-Lisbon.webp',
    title: 'Downtown Streets',
    subtitle: 'Cobblestone streets with shops and restaurants'
  }
];

// ==================== LISBON IMAGES ====================
export const lisbonPageImages = [
  {
    id: 'urbanoasis.lisbon.001',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/7j8a3hdd_2-days-in-Lisbon-itinerary-Lisboa-sign-feat-image.jpg',
    title: 'Welcome to Lisboa',
    subtitle: 'The iconic Lisboa sign overlooking the city'
  },
  {
    id: 'urbanoasis.lisbon.002',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/v0kk1ndu_AdobeStock_382180612-1500x842.jpeg',
    title: 'Cristo Rei & 25 de Abril Bridge',
    subtitle: 'Iconic Christ the King statue overlooking the Tagus River'
  },
  {
    id: 'urbanoasis.lisbon.003',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/1ethihqm_AdobeStock_593917660-1500x813.jpeg',
    title: 'Alfama Viewpoint',
    subtitle: "Panoramic views over Lisbon's oldest neighborhood"
  },
  {
    id: 'urbanoasis.lisbon.004',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/s7via8ax_lisbon-museums-1.jpg',
    title: 'Church of São Roque',
    subtitle: 'Stunning Baroque interior with gilded chapels'
  },
  {
    id: 'urbanoasis.lisbon.005',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/wd5l44kh_Travel-Lemming-writer-Clara-at-the-Alfama-District.jpg',
    title: 'Alfama District',
    subtitle: "Wander through Lisbon's oldest neighborhood"
  },
  {
    id: 'urbanoasis.lisbon.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/zofp4oj3_Visiter-Lisbonne-4.jpg',
    title: 'Belém Tower',
    subtitle: 'UNESCO World Heritage fortress on the Tagus River'
  },
  {
    id: 'urbanoasis.lisbon.007',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/w7xsv9cw_lisbon_portugal_IMG_6326.jpg',
    title: 'Padrão dos Descobrimentos',
    subtitle: 'Monument to the Discoveries celebrating Portuguese explorers'
  },
  {
    id: 'urbanoasis.lisbon.008',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/ngbbzfig_lisbon-lisboa-queen-of-the-sea.webp',
    title: 'Queen of the Sea',
    subtitle: "Stunning aerial view of Lisbon's waterfront"
  },
  {
    id: 'urbanoasis.lisbon.009',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/m76kpt69_caption.jpg',
    title: 'Historic Tram 28',
    subtitle: "Iconic yellow tram winding through Alfama's narrow streets"
  },
  {
    id: 'urbanoasis.lisbon.010',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/am84vqdu_hero_image_44_176108138549988ed7.jpg',
    title: 'Praça do Comércio',
    subtitle: 'Grand riverside square with the Arco da Rua Augusta'
  },
  {
    id: 'urbanoasis.lisbon.011',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/xc28j1xy_iStock-1137863101.jpg.webp',
    title: 'São Jorge Castle View',
    subtitle: 'Medieval fortress overlooking historic Alfama at sunset'
  },
  {
    id: 'urbanoasis.lisbon.012',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/wmywqzur_20241205_173427-scaled.webp',
    title: 'Sunset in Lisbon',
    subtitle: 'Magical evening light over the capital'
  },
  {
    id: 'urbanoasis.lisbon.013',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/78aks3d0_Museu%20Arqueol%C3%B3gico%20do%20Carmo%20Archaeological%20Museum%20Lisbon%20convent%20city%20break%20Elle%20Field.jpg',
    title: 'Carmo Convent Ruins',
    subtitle: 'Gothic arches of the 1755 earthquake memorial'
  },
  {
    id: 'urbanoasis.lisbon.014',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/071abd7z_Aguas-Livres.jpg',
    title: 'Águas Livres Aqueduct',
    subtitle: 'Historic 18th-century aqueduct with grand stone arches'
  }
];

// ==================== SINTRA IMAGES ====================
export const sintraPageImages = [
  {
    id: 'urbanoasis.sintra.001',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/9rznsdwz_Sintra2.jpg',
    title: 'Pena Palace',
    subtitle: 'Colorful fairytale castle on the hilltop'
  },
  {
    id: 'urbanoasis.sintra.002',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/y8mjbc8s_Magical-Medieval-Sintra-Portugal.jpg',
    title: 'Pena Palace Bridge',
    subtitle: 'Arched walkways and vibrant architecture'
  },
  {
    id: 'urbanoasis.sintra.003',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/mf58kb6e_Sintra5.jpg',
    title: 'Moorish Castle',
    subtitle: 'Ancient stone walls with Pena Palace beyond'
  },
  {
    id: 'urbanoasis.sintra.004',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/joj0ul9j_sintra3.webp',
    title: 'Quinta da Regaleira Palace',
    subtitle: 'Gothic mansion with mystical gardens'
  },
  {
    id: 'urbanoasis.sintra.005',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/sgvrhskd_Sintra6.jpg',
    title: 'Initiation Well',
    subtitle: 'Mystical spiral staircase at Quinta da Regaleira'
  },
  {
    id: 'urbanoasis.sintra.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/6h7aksgv_IMG_9530-10.26.38-AM-scaled.webp',
    title: 'Quinta da Regaleira Rotunda',
    subtitle: 'Gothic-Moorish interior with ornate floor mosaic'
  },
  {
    id: 'urbanoasis.sintra.007',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/wstz60b8_muslim-travel-guide-Sintra-Portugal.webp',
    title: 'Queluz Palace Gardens',
    subtitle: 'Baroque gardens with mythological fountain sculptures'
  },
  {
    id: 'urbanoasis.sintra.008',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/4movwm84_Sintra1.jpg',
    title: 'Azenhas do Mar',
    subtitle: 'Coastal village with clifftop ocean pool'
  },
  {
    id: 'urbanoasis.sintra.009',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/csn8hu2k_Sintra-4.jpg',
    title: 'Pena Palace Terraces',
    subtitle: 'Vibrant walkways with blue sky and colorful towers'
  },
  {
    id: 'urbanoasis.sintra.010',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/s7lovfl4_Inside-the-Pena-Palace.jpg',
    title: 'Inside Pena Palace',
    subtitle: 'Ornate royal interiors and detailed tilework'
  },
  {
    id: 'urbanoasis.sintra.011',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/dys4c7qp_99.jpg',
    title: 'Sintra National Palace Interior',
    subtitle: 'Sala dos Brasões with stunning azulejo tiles and painted ceiling'
  },
  {
    id: 'urbanoasis.sintra.012',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/qoujcq6n_National-Palace-Sintra-Port.webp',
    title: 'Sintra National Palace',
    subtitle: 'Iconic twin chimneys in town center'
  },
  {
    id: 'urbanoasis.sintra.013',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/avzmdacb_Monserrate-Palace-Sintra-Portugal-04985.jpg',
    title: 'Quinta da Regaleira Gardens',
    subtitle: 'Lush tropical gardens with ornate fountain'
  },
  {
    id: 'urbanoasis.sintra.014',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/0ufdc68s_Pal%C3%A1cio_Monserrate_%281%29.jpg',
    title: 'Quinta da Regaleira Tower',
    subtitle: 'Neo-Gothic palace tower with exotic gardens'
  },
  {
    id: 'urbanoasis.sintra.015',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/3hkghzje_Sintra-and-Pena-Palace-Portugal.jpg',
    title: 'Pena Palace Pathway',
    subtitle: 'Tropical gardens leading to the palace'
  },
  {
    id: 'urbanoasis.sintra.016',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/qojrnrpq_TNE-Things-To-Do-Sintra-Travel-Guide-Portugal-Pena-Palace-2.jpg',
    title: 'Pena Palace Arches',
    subtitle: 'Panoramic coastline views from palace terraces'
  },
  {
    id: 'urbanoasis.sintra.017',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/awfn2tsb_Peninha-Sanctuary.jpg',
    title: 'Peninha Sanctuary',
    subtitle: 'Hilltop chapel with dramatic mountain views'
  },
  {
    id: 'urbanoasis.sintra.018',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/c385cuku_Sintra-National-Palace-Sintra-Portugal-05045.jpg',
    title: 'Sintra National Palace Courtyard',
    subtitle: 'Historic courtyard with azulejo tiles and spiral column'
  },
  {
    id: 'urbanoasis.sintra.019',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/ilfr06cr_Convento-dos-Capuchos.jpg',
    title: 'Convento dos Capuchos',
    subtitle: 'The Cork Convent - a hidden Franciscan monastery in the forest'
  },
  {
    id: 'urbanoasis.sintra.020',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/uilp07bx_parques_de_sintra_palacio_de_queluz_image_03.jpeg',
    title: 'Queluz Palace Throne Room',
    subtitle: 'Opulent ballroom with chandeliers and frescoed ceiling'
  }
];

// ==================== OBIDOS IMAGES ====================
export const obidosPageImages = [
  {
    id: 'urbanoasis.obidos.001',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/odeiytm7__010aa9b9-a093-41eb-b2be-5657c3011731.jpg',
    title: 'Medieval Óbidos',
    subtitle: 'Panoramic view of the walled town at golden hour'
  },
  {
    id: 'urbanoasis.obidos.002',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/tealkkpq_Things-to-do-in-Obidos-Portugal.webp',
    title: 'Aerial View of Óbidos',
    subtitle: 'Medieval walled town nestled in rolling green hills'
  },
  {
    id: 'urbanoasis.obidos.003',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/usxiack3_IMG2486-1.jpg',
    title: 'Rua Direita',
    subtitle: 'Charming cobblestone street lined with artisan shops'
  },
  {
    id: 'urbanoasis.obidos.004',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/td5ahaws_GettyImages-182856050.webp',
    title: 'Óbidos Castle',
    subtitle: 'The imposing 12th-century medieval fortress'
  },
  {
    id: 'urbanoasis.obidos.005',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/0019l5of_novembro-banner-1125x750.avif',
    title: 'Town Within Walls',
    subtitle: 'Explore the enchanting streets of this living museum'
  },
  {
    id: 'urbanoasis.obidos.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/y12jddby_20161112_115150.jpg.webp',
    title: 'The Literary Man Hotel',
    subtitle: 'Famous bookstore bar with thousands of books and fine spirits'
  },
  {
    id: 'urbanoasis.obidos.007',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/cjm9gaca_9-Best-Things-to-do-in-Obidos-Portugal-and-Where-to-Stay1.jpg',
    title: 'Porta da Vila',
    subtitle: 'Main gate adorned with stunning azulejo tiles and painted ceiling'
  },
  {
    id: 'urbanoasis.obidos.008',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/b5a57lso_s_maria_capa.webp',
    title: 'Igreja de Santa Maria',
    subtitle: 'Renaissance church with azulejo walls and gilded Baroque altar'
  },
  {
    id: 'urbanoasis.obidos.009',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/8hx8uf36_obidos-portugal-8.jpg',
    title: 'Flower-Lined Streets',
    subtitle: 'Whitewashed houses with yellow trim and cascading blooms'
  },
  {
    id: 'urbanoasis.obidos.010',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/wjywuva3_shutterstockRF371864500.avif',
    title: 'Walking the Walls',
    subtitle: 'Mile-long medieval ramparts with panoramic views'
  }
];

// ==================== TOMAR IMAGES ====================
export const tomarPageImages = [
  {
    id: 'urbanoasis.tomar.001',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/oxtxtkdf_shutterstock_2456398161_e3d7178beb.jpg',
    title: 'Tomar & Ponte Nova',
    subtitle: 'Historic bridge over the Nabão River with the Templar castle above'
  },
  {
    id: 'urbanoasis.tomar.002',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/e4upmqvy_tomar_portugal_castle_tours.jpeg',
    title: 'Convent of Christ',
    subtitle: 'Aerial view of the UNESCO World Heritage Templar complex'
  },
  {
    id: 'urbanoasis.tomar.003',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/bm4shg32_tomar-aqueduct.jpg',
    title: 'Pegões Aqueduct',
    subtitle: '6km 16th-century aqueduct with 180 arches'
  },
  {
    id: 'urbanoasis.tomar.004',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/ywzyuo7o_manueline-window-charola-convent-of-christ-tomar.jpg',
    title: 'Manueline Architecture',
    subtitle: 'Gothic and Manueline towers of the Convent of Christ'
  },
  {
    id: 'urbanoasis.tomar.005',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/v96hc9tk_Lisbon-the-Templars-and-Tomar-by-Train-10-min-scaled-1.jpg',
    title: 'Cloister of the Convent',
    subtitle: 'Renaissance courtyard with ornate Gothic details'
  },
  {
    id: 'urbanoasis.tomar.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/76bg1dez_portugal-tomar-church-oratory-0101719-rs.jpg',
    title: 'The Charola',
    subtitle: 'Ornate Templar round church with gilded Manueline altar'
  },
  {
    id: 'urbanoasis.tomar.007',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/vtot8tdo_s_maria_capa.webp',
    title: 'Igreja de São Francisco',
    subtitle: 'Church interior adorned with blue and white azulejo tiles'
  },
  {
    id: 'urbanoasis.tomar.008',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/nv0aya1j_Tomar_-_Portugal_%2832771230342%29.jpg',
    title: 'Rio Nabão & Town',
    subtitle: 'Panoramic view of Tomar along the riverside'
  }
];

// ==================== EVORA IMAGES ====================
export const evoraPageImages = [
  {
    id: 'urbanoasis.evora.001',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/klnivb3e_evora_portugal_magik_tours_1426305434.webp',
    title: 'Roman Temple of Évora',
    subtitle: '1st-century Roman temple illuminated at twilight'
  },
  {
    id: 'urbanoasis.evora.002',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/h6miwvax_233479-Evora-Cathedral.webp',
    title: 'Sé de Évora',
    subtitle: 'Gothic cathedral with fortress-like towers and rose window'
  },
  {
    id: 'urbanoasis.evora.003',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/olk1nj13_4_Alentejo_ARTA_821631bb23140209ea99c8f810f75634.jpg',
    title: 'Praça do Giraldo',
    subtitle: 'Historic main square with arcaded buildings and lively atmosphere'
  },
  {
    id: 'urbanoasis.evora.004',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/jppaqk13_Evora-University.png',
    title: 'University of Évora',
    subtitle: 'Baroque courtyard with ornate fountain and arcades'
  },
  {
    id: 'urbanoasis.evora.005',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/rlmd7kxe_545549.jpg',
    title: 'Igreja de São Francisco',
    subtitle: 'Church housing the famous Chapel of Bones'
  },
  {
    id: 'urbanoasis.evora.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/g1fmjye3_Depositphotos_177242702_L.webp',
    title: 'Cathedral Rooftop View',
    subtitle: 'Panoramic vista over red-tiled rooftops and Alentejo plains'
  },
  {
    id: 'urbanoasis.evora.007',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/c6ad1m8u_catedral-de-evora.jpg.webp',
    title: 'Cathedral Terrace',
    subtitle: 'Gothic tower and battlements from the rooftop walkway'
  },
  {
    id: 'urbanoasis.evora.008',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/86qhp8mr_adobestock-182047939.jpeg',
    title: 'Historic Streets',
    subtitle: 'Whitewashed houses with yellow trim in the old town'
  }
];

// ==================== NAZARE IMAGES ====================
export const nazarePageImages = [
  {
    id: 'urbanoasis.nazare.001',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/5sg4canb_Nazare-Portugal.jpg',
    title: 'Nazaré from Above',
    subtitle: 'Aerial view of the golden beach and red-roofed town'
  },
  {
    id: 'urbanoasis.nazare.002',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/w4tqgqka_adobestock-518853356-1500x1000.jpeg',
    title: 'Funicular Railway',
    subtitle: 'Historic lift connecting the beach to Sítio viewpoint'
  },
  {
    id: 'urbanoasis.nazare.003',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/qjja6uwh_DSC00424.webp',
    title: 'Giant Waves at Praia do Norte',
    subtitle: 'World-famous big wave surfing spot with lighthouse fortress'
  },
  {
    id: 'urbanoasis.nazare.004',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/7e79m36n_Nazare_City7.webp',
    title: 'Sunset Over Nazaré',
    subtitle: 'Dramatic cliffs and coastline bathed in golden light'
  },
  {
    id: 'urbanoasis.nazare.005',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/g53tb77w_nazare_portugal-25.jpg',
    title: 'Sea Cave & Beach',
    subtitle: 'Natural rock archway framing the Atlantic shore'
  },
  {
    id: 'urbanoasis.nazare.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/7f9qjgn5_nazare-wave.webp',
    title: 'Big Wave Surfing',
    subtitle: 'Surfers ride colossal waves while crowds watch from the lighthouse'
  }
];

// ==================== PENICHE IMAGES ====================
export const penichePageImages = [
  {
    id: 'urbanoasis.peniche.001',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/it8v43oq_Surfing-Peniche-scaled.jpg',
    title: 'Peniche Peninsula',
    subtitle: 'Aerial view of the historic fishing town on its dramatic rocky headland'
  },
  {
    id: 'urbanoasis.peniche.002',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/3dpdhxvg_peniche-fortress.jpg',
    title: 'Fortaleza de Peniche',
    subtitle: '16th-century fortress with arched bridge and coastal ramparts'
  },
  {
    id: 'urbanoasis.peniche.003',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/o4zlk6ko_232339-Leiria-District.webp',
    title: 'Berlengas Bridge',
    subtitle: 'Stone bridge connecting to the São João Baptista fortress on Berlenga Island'
  },
  {
    id: 'urbanoasis.peniche.004',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/zbi6yfsd_uutzWMmjMk.jpeg',
    title: 'Fortress Ramparts',
    subtitle: 'Historic stone walls overlooking the Atlantic Ocean'
  },
  {
    id: 'urbanoasis.peniche.005',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/hbeaf5jh_peniche1-1_5fc00a08_.png',
    title: 'Yellow Arched Bridge',
    subtitle: 'Iconic entrance to the fortress with turquoise cove below'
  },
  {
    id: 'urbanoasis.peniche.006',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/3pmx29vs_berlenga-fortress-peniche.jpg.webp',
    title: 'São João Baptista Fort',
    subtitle: 'Island fortress with stone causeway and crystal-clear turquoise waters'
  },
  {
    id: 'urbanoasis.peniche.007',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/7ewbx717_Fortaleza-de-Peniche-Portugal.jpg',
    title: 'Fortress at Sunset',
    subtitle: 'Golden hour view of the fortress walls and yellow-arched entrance'
  },
  {
    id: 'urbanoasis.peniche.008',
    url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/exjxss6j_adobestock-692602795-1500x999.jpeg',
    title: 'Rugged Coastline',
    subtitle: "Dramatic cliffs and Atlantic waves along Peniche's shore"
  }
];

// ==================== PROPERTY / INTERIOR IMAGES ====================
export const propertyImages = [
  {
    id: 'urbanoasis.property.001',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/o2pqe0x5_Photo1.jpg',
    title: 'Living Room',
    subtitle: 'Bright modern living space with garden view'
  },
  {
    id: 'urbanoasis.property.002',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/aolz9kpd_Photo2.jpg',
    title: 'Outdoor Terrace',
    subtitle: 'Private patio with lounge seating'
  },
  {
    id: 'urbanoasis.property.003',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/wkcfnvr9_Photo3.jpg',
    title: 'Master Bedroom',
    subtitle: 'Comfortable queen bed with quality linens'
  },
  {
    id: 'urbanoasis.property.004',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/1vktzk3o_Photo4.jpg',
    title: 'Kitchen',
    subtitle: 'Fully equipped modern kitchen'
  },
  {
    id: 'urbanoasis.property.005',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/2dqoegzv_Photo5.jpg',
    title: 'Bathroom',
    subtitle: 'Clean modern bathroom with walk-in shower'
  },
  {
    id: 'urbanoasis.property.006',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/3rnpyqdp_Photo6.jpg',
    title: 'Dining Area',
    subtitle: 'Indoor-outdoor dining space'
  },
  {
    id: 'urbanoasis.property.007',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/iilsgm3c_Photo7.jpg',
    title: 'Garden View',
    subtitle: 'Lush private garden setting'
  },
  {
    id: 'urbanoasis.property.008',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/ik2kwxj3_Photo8.jpg',
    title: 'Interior Details',
    subtitle: 'Thoughtful design touches throughout'
  },
  {
    id: 'urbanoasis.property.009',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/58sn9h2h_Photo9.jpg',
    title: 'Second Bedroom',
    subtitle: 'Cozy guest bedroom option'
  },
  {
    id: 'urbanoasis.property.010',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/yixr7t8r_Photo10.jpg',
    title: 'Workspace',
    subtitle: 'Dedicated work area with good lighting'
  },
  {
    id: 'urbanoasis.property.011',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/bwdrx88p_Photo11.jpg',
    title: 'Evening Ambiance',
    subtitle: 'Warm evening lighting on the terrace'
  },
  {
    id: 'urbanoasis.property.012',
    url: 'https://customer-assets.emergentagent.com/job_cascais-luxury-apt/artifacts/qzqpf8yw_Photo12.jpg',
    title: 'Property Entrance',
    subtitle: 'Welcome to Urban Oasis Cascais'
  }
];

// ==================== MAP IMAGE ====================
export const mapImage = {
  id: 'urbanoasis.map.001',
  url: 'https://customer-assets.emergentagent.com/job_preview-gen/artifacts/jel1vsp8_image.png',
  title: 'Cascais Location Map',
  subtitle: 'Property location in downtown Cascais with beach and marina visible'
};

// ==================== HELPER FUNCTIONS ====================

// Get image by ID
export const getImageById = (id) => {
  const allImages = [
    ...cascaisPageImages,
    ...lisbonPageImages,
    ...sintraPageImages,
    ...obidosPageImages,
    ...tomarPageImages,
    ...evoraPageImages,
    ...nazarePageImages,
    ...penichePageImages,
    ...propertyImages
  ];
  return allImages.find(img => img.id === id);
};

// Get all images for a specific location
export const getImagesByLocation = (location) => {
  const locationMap = {
    cascais: cascaisPageImages,
    lisbon: lisbonPageImages,
    sintra: sintraPageImages,
    obidos: obidosPageImages,
    tomar: tomarPageImages,
    evora: evoraPageImages,
    nazare: nazarePageImages,
    peniche: penichePageImages,
    property: propertyImages
  };
  return locationMap[location] || [];
};

// Export all images as a single object for easy access
export const allImages = {
  cascais: cascaisPageImages,
  lisbon: lisbonPageImages,
  sintra: sintraPageImages,
  obidos: obidosPageImages,
  tomar: tomarPageImages,
  evora: evoraPageImages,
  nazare: nazarePageImages,
  peniche: penichePageImages,
  property: propertyImages
};

export default allImages;
